import { useNavigate } from "@tanstack/react-router"
import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useDeleteGmailIntegrationMutation } from "modules/settings/hooks/gmail/useDeleteGmailIntegrationMutation"
import { useGmailIntegrationsQuery } from "modules/settings/hooks/gmail/useGmailIntegrationsQuery"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { Route as DeleteGmailIntegrationRoute } from "routes/_base/_auth/settings/channels/gmail/deleteIntegration.$id"

export const DeleteGmailIntegration = () => {
  const { t } = useTranslation()
  const { id } = DeleteGmailIntegrationRoute.useParams()
  const navigate = useNavigate()
  const { mutateAsync } = useDeleteGmailIntegrationMutation()
  const [isLoading, setIsLoading] = useState(false)
  const { data } = useGmailIntegrationsQuery()
  const integrationInfo = data?.find((e) => e.id === id)

  const onCancel = () => {
    navigate({ to: "/settings/channels/gmail" })
  }

  const onDelete = async () => {
    setIsLoading(true)

    await mutateAsync({ id })
      .then(() => {
        onOpenChange()
      })
      .catch(() => {
        setIsLoading(false)
      })
  }

  const onOpenChange = (isOpen: boolean = false) => {
    if (!isOpen) {
      navigate({ to: "/settings/channels/gmail" })
    }
  }

  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("settings.integrations.gmail.deleteIntegration.title")}</DialogTitle>
          <DialogDescription>
            <Trans
              i18nKey={"settings.integrations.gmail.deleteIntegration.description"}
              values={{ email: integrationInfo?.email }}
              components={{ b: <b /> }}
            />
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2">
          <DialogFooter>
            <Button variant={"secondary"} onClick={onCancel} disabled={isLoading}>
              {t("settings.integrations.gmail.deleteIntegration.actions.cancel")}
            </Button>
            <Button onClick={onDelete} disabled={isLoading}>
              {t("settings.integrations.gmail.deleteIntegration.actions.delete")}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}
